export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const CLOSE_SNACKBAR_NOTIFICATION = 'CLOSE_SNACKBAR_NOTIFICATION';

export const closeSnackbarNotification = (key) => ({
  type: CLOSE_SNACKBAR_NOTIFICATION,
  key
});

export const showNotification = (notificationType, message) => ({
  type: SHOW_NOTIFICATION,
  notificationType,
  message
});
